import React, { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import './deactivate.css';

const DeactivationMessage = () => {
    const { user } = useContext(AuthContext);
    return (
        <div>
            {!user ? <div className="lending-page-container">
                <div className="container-fluid container-fluid-custom ">
                    <div className="deactivate-page-container">
                        <h3> <img src="/assets/images/logo.png" alt="Username" /> PointSnaps</h3>
                        <div>
                            <h2>We are sorry to see you go</h2>
                            <h4>We are just confirming that your PointSnaps account is permanently deleted.</h4>
                        </div>
                    </div>
                </div>
            </div> : null}
        </div>
    )
}
export default DeactivationMessage;


// WEBPACK FOOTER //
// ./src/components/deactivationMessage/deactivationMessage.js